// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2nHeH","label":"CategoryService_label__1XWWq","location":"CategoryService_location__2E5WZ"};